// This file is being used for adding information of our products that we'll use on our website

const data= {
    productItems:[
        {
            id:"1",
            name:"Duran",
            price: 199,
            image: "./pics/Duran.jpeg"
        },
        {
            id:"2",
            name:"Carnera",
            price: 299,
            image: "./pics/carnera.jpeg"
        },
        {
            id:"3",
            name:"Tunney",
            price: 299,
            image: "./pics/Tunney.jpeg"
        },
        {
            id:"4",
            name:"Cactus",
            price: 499,
            image: "./pics/Cactus.jpeg"
        },
        {
            id:"5",
            name:"Trescia",
            price: 399,
            image: "./pics/Trscia.jpeg"
        },
        {
            id:"6",
            name:"Rivolta",
            price: 199,
            image: "./pics/Rivolta.jpeg"
        },
        {
            id:"7",
            name:"Maison",
            price: 999,
            image: "./pics/Maison.jpeg"
        },
        {
            id:"8",
            name:"Repiace",
            price: 499,
            image: "./pics/Repiace.jpeg"
        }
    ]
}


export default data;